/* Header, mega menu, search drawer, mobile menu — ported from mockup script.js:69-156. Needs cr-global.js. */

if (!customElements.get('cr-header')) {
  customElements.define('cr-header', class extends HTMLElement {
    connectedCallback() {
      this.megas = Array.from(this.querySelectorAll('[data-cr-mega]'));
      this.megas.forEach((li) => this.setupMega(li));

      this.onEscape = () => this.megas.forEach((li) => this.setMega(li, false));
      document.addEventListener('cr:escape', this.onEscape);

      const searchBtn = this.querySelector('[data-cr-search-open]');
      if (searchBtn) searchBtn.addEventListener('click', () => {
        const drawer = this.querySelector('cr-search-drawer');
        if (drawer) drawer.open(searchBtn);
      });

      const burger = this.querySelector('[data-cr-menu-open]');
      if (burger) burger.addEventListener('click', () => {
        const drawer = this.querySelector('cr-menu-drawer');
        if (drawer) drawer.open(burger);
      });

      const cartBtn = this.querySelector('[data-cr-cart-open]');
      if (cartBtn) cartBtn.addEventListener('click', (e) => {
        const drawer = document.querySelector('cr-cart-drawer');
        if (!drawer || window.location.pathname === (window.CR ? window.CR.routes.cartUrl : '/cart')) return; // no drawer → normal cart link
        e.preventDefault();
        drawer.open(cartBtn);
      });

      this.countEl = this.querySelector('[data-cr-cart-count]');
      this.onCart = (e) => {
        if (!this.countEl || !e.detail || !e.detail.cart) return;
        const qty = e.detail.cart.item_count;
        this.countEl.textContent = qty;
        this.countEl.hidden = qty === 0;
      };
      document.addEventListener('cr:cart:updated', this.onCart);

      if (window.Shopify && window.Shopify.designMode) {
        this.onBlockSelect = (e) => {
          if (!this.contains(e.target)) return;
          const li = e.target.closest('[data-cr-mega]') || this.megas[0];
          if (li) this.setMega(li, true);
        };
        this.onBlockDeselect = (e) => { if (this.contains(e.target)) this.megas.forEach((li) => this.setMega(li, false)); };
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    disconnectedCallback() {
      document.removeEventListener('cr:escape', this.onEscape);
      document.removeEventListener('cr:cart:updated', this.onCart);
      if (this.onBlockSelect) {
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
      }
    }

    // mockup js:70-75
    setupMega(li) {
      const btn = li.querySelector(':scope > button');
      let closeTimer;
      li.addEventListener('mouseenter', () => { clearTimeout(closeTimer); this.setMega(li, true); });
      li.addEventListener('mouseleave', () => { closeTimer = setTimeout(() => this.setMega(li, false), 120); });
      btn.addEventListener('click', () => this.setMega(li, !li.classList.contains('is-open')));
      li.addEventListener('focusout', (e) => { if (!li.contains(e.relatedTarget)) this.setMega(li, false); });

      // mockup js:78-120 — hovering / focusing a category shows its products
      li.querySelectorAll('[data-cr-mega-link]').forEach((a) => {
        const show = () => this.showView(li, a.dataset.crMegaLink);
        a.addEventListener('mouseenter', show);
        a.addEventListener('focus', show);
      });
    }

    setMega(li, open) {
      li.classList.toggle('is-open', open);
      const btn = li.querySelector(':scope > button');
      if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (!open) this.showView(li, '0');
    }

    showView(li, key) {
      if (li.dataset.crView === key) return;
      li.dataset.crView = key;
      li.querySelectorAll('[data-cr-mega-link]').forEach((a) => a.classList.toggle('is-active', a.dataset.crMegaLink === key));
      li.querySelectorAll('[data-cr-mega-view]').forEach((v) => { v.hidden = v.dataset.crMegaView !== key; });
      const panel = li.querySelector('[data-cr-mega-panel]');
      if (!panel) return;
      panel.classList.remove('is-swapping');
      void panel.offsetWidth;
      panel.classList.add('is-swapping');
    }
  });
}

if (!customElements.get('cr-search-drawer')) {
  customElements.define('cr-search-drawer', class extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]');
      this.out = this.querySelector('[data-cr-search-results]');
      this.panel = this.querySelector('.cr-search__panel');
      this.querySelectorAll('[data-cr-search-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      let t;
      this.input.addEventListener('input', () => { clearTimeout(t); t = setTimeout(() => this.run(this.input.value), 200); });
      this.querySelectorAll('.cr-chip').forEach((c) => c.addEventListener('click', () => {
        this.input.value = c.textContent;
        this.run(c.textContent);
        this.input.focus();
      }));
    }

    open(trigger) {
      window.CR.openOverlay(this, { kind: 'search', box: this.panel, trigger: trigger, focus: 'input[type="search"]' });
    }

    close() { window.CR.closeOverlay('search'); }

    esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;'); }

    // mockup js:142-152
    run(raw) {
      const q = raw.trim().toLowerCase();
      if (this.controller) this.controller.abort();
      if (!q) { this.out.innerHTML = ''; return; }
      this.controller = new AbortController();
      const url = new URL(this.dataset.suggestUrl, window.location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      url.searchParams.set('resources[options][fields]', 'title,vendor,body,product_type,variants.title');
      url.searchParams.set('section_id', 'cr-search-data');
      fetch(url.toString(), { signal: this.controller.signal, credentials: 'same-origin' })
        .then((r) => r.text())
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const items = doc.querySelectorAll('[data-cr-search-items] .cr-result');
          if (!items.length) {
            const msg = this.esc(this.dataset.labelEmpty || '').replace('[terms]', this.esc(q));
            this.out.innerHTML = '<p class="cr-search__empty">' + msg + '</p>';
            return;
          }
          const all = new URL(this.dataset.searchUrl, window.location.origin);
          all.searchParams.set('q', q);
          this.out.innerHTML = '<p class="cr-search__label">' + this.esc(this.dataset.labelProducts || '') + '</p>' +
            '<div class="cr-search__grid">' + Array.from(items).map((a) => a.outerHTML).join('') + '</div>' +
            '<a class="cr-text-link cr-search__all" href="' + this.esc(all.pathname + all.search) + '">' + this.esc(this.dataset.labelAll || '') + '</a>';
        })
        .catch((e) => { if (e.name !== 'AbortError') console.error(e); });
    }
  });
}

if (!customElements.get('cr-menu-drawer')) {
  customElements.define('cr-menu-drawer', class extends HTMLElement {
    connectedCallback() {
      this.box = this.querySelector('.cr-panel__box');
      this.querySelectorAll('[data-cr-menu-close]').forEach((b) => b.addEventListener('click', () => this.close()));
      // mockup js:135-137 — accordion
      this.querySelectorAll('.cr-drawer__parent > button').forEach((btn) => {
        btn.addEventListener('click', () => {
          const li = btn.parentElement;
          const open = !li.classList.contains('is-open');
          li.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    }

    open(trigger) { window.CR.openOverlay(this, { kind: 'menu', box: this.box, trigger: trigger }); }
    close() { window.CR.closeOverlay('menu'); }
  });
}
